<template>
  <div id="app">
    <chrome-warning />
    <router-view />
  </div>
</template>

<script>
import ChromeWarning from '@/components/ChromeWarning';
import { mapState } from 'vuex';

export default {
  components: {
    ChromeWarning,
  },
  computed: {
    ...mapState({
      common: state => state.common,
    }),
  },
};
</script>
